// Extraction du mot cible du knockout depuis le texte saisi par
// l'utilisateur, pour les 9 ecritures non-latines. Marqueur unifie sur les
// 9 : le mot cible est entoure d'ASTERISQUES *mot* a la saisie, retires de
// la phrase finale -- seul le mot qu'ils entourent recoit le traitement
// knockout. Uniformise deux conventions differentes qui coexistaient avant
// (MAJUSCULES pour cyrillique/grec, parentheses pour les 7 autres) --
// source de confusion (demande Rudy, 18 septembre 2026). Jamais utilise
// pour le latin (MAJUSCULES conservees, fonctionnalite historique la plus
// utilisee du site -- pas de raison de la changer).
//
// Retourne null si aucun marqueur de knockout valide n'est trouve (l'appelant
// doit alors traiter le texte comme "pas encore pret a generer").
export function extractKnockoutTarget(text) {
  const match = text.match(/\*([^*]+)\*/);
  if (!match) return null;
  const target = match[1].trim();
  if (!target) return null;
  const sentence = text.slice(0, match.index) + target + text.slice(match.index + match[0].length);
  return { sentence, target };
}

// Inverse d'extractKnockoutTarget : reconstruit le texte AVEC son marqueur de
// knockout, pour l'afficher/l'editer (dashboard de moderation -- le mot
// cible n'est jamais visible dans le texte "propre" stocke en base, faute
// d'asterisques).
export function formatKnockoutDisplayText(sentence, target) {
  if (!target) return sentence;
  const idx = sentence.indexOf(target);
  if (idx === -1) return sentence;
  return sentence.slice(0, idx) + '*' + target + '*' + sentence.slice(idx + target.length);
}
